var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    {
      staticClass: "drop-shadow afterSave",
      style: { border: "none" },
      attrs: { "max-width": "850" },
    },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title")))]),
      _c(
        "w-scroll-view",
        { staticClass: "grow", attrs: { tag: "w-card-content" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { staticClass: "box", attrs: { sm: "12", md: "6" } },
                _vm._l(_vm.cash, function (item, index) {
                  return _c(
                    "w-row",
                    {
                      key: item[0],
                      class: { stripe: index % 2 },
                      attrs: { "no-margin": "" },
                    },
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12", sm: "5" } },
                        [
                          _c("w-input-number", {
                            ref: "amount",
                            refInFor: true,
                            model: {
                              value: item[1],
                              callback: function ($$v) {
                                _vm.$set(item, 1, $$v)
                              },
                              expression: "item[1]",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        {
                          staticClass: "center-me",
                          attrs: { xs: "12", sm: "4" },
                        },
                        [
                          _vm._v(
                            " x  € " +
                              _vm._s(_vm._f("printHumanFloat")(item[0])) +
                              " = "
                          ),
                        ]
                      ),
                      _c(
                        "w-col",
                        {
                          staticClass: "center-me amount",
                          attrs: { xs: "12", sm: "3" },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm._f("printHumanFloat")(item[0] * item[1]))
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
              _c("w-col", { attrs: { sm: "0", md: "1" } }),
              _c(
                "w-col",
                { style: { padding: "0 0 0 0" }, attrs: { sm: "12", md: "5" } },
                [
                  _c(
                    "div",
                    { staticClass: "box" },
                    [
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { style: { padding: "15px" }, attrs: { sm: "12" } },
                            [
                              _c("app-select-bank-type", {
                                attrs: { fancy: "", "use-ids": "" },
                                model: {
                                  value: _vm.bank,
                                  callback: function ($$v) {
                                    _vm.bank = $$v
                                  },
                                  expression: "bank",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-row",
                        [
                          _c("w-col", { attrs: { sm: "6" } }, [
                            _vm._v(_vm._s(_vm.$ct("saldo"))),
                          ]),
                          _c(
                            "w-col",
                            { staticClass: "amount", attrs: { sm: "6" } },
                            [
                              _c("w-input-number", {
                                staticClass: "aR",
                                attrs: { decimals: 2 },
                                model: {
                                  value: _vm.saldo,
                                  callback: function ($$v) {
                                    _vm.saldo = $$v
                                  },
                                  expression: "saldo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-row",
                        [
                          _c("w-col", { attrs: { sm: "6" } }, [
                            _vm._v(_vm._s(_vm.$ct("total"))),
                          ]),
                          _c(
                            "w-col",
                            { staticClass: "amount", attrs: { sm: "6" } },
                            [
                              _vm._v(
                                _vm._s(_vm._f("printHumanFloat")(_vm.totalIn))
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "w-row",
                        [
                          _c("w-col", { attrs: { sm: "6" } }, [
                            _vm._v(_vm._s(_vm.$ct("difference"))),
                          ]),
                          _c(
                            "w-col",
                            { staticClass: "amount", attrs: { sm: "6" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("printHumanFloat")(_vm.difference)
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-row",
                        [
                          _c("w-col", { attrs: { sm: "6" } }, [
                            _vm._v(_vm._s(_vm.$ct("start"))),
                          ]),
                          _c(
                            "w-col",
                            { staticClass: "amount", attrs: { sm: "6" } },
                            [
                              _c("w-input-number", {
                                staticClass: "aR",
                                model: {
                                  value: _vm.start,
                                  callback: function ($$v) {
                                    _vm.start = $$v
                                  },
                                  expression: "start",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-row",
                        [
                          _c("w-col", { attrs: { sm: "6" } }, [
                            _vm._v(_vm._s(_vm.$ct("deposit"))),
                          ]),
                          _c(
                            "w-col",
                            { staticClass: "amount", attrs: { sm: "6" } },
                            [
                              _vm._v(
                                _vm._s(_vm._f("printHumanFloat")(_vm.toDeposit))
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.save")))]
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.startTransfer,
            callback: function ($$v) {
              _vm.startTransfer = $$v
            },
            expression: "startTransfer",
          },
        },
        [
          _c(
            "w-card",
            { attrs: { "max-width": "500" } },
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("transfer-title")))]),
              _c(
                "w-card-content",
                { style: { padding: "0px" } },
                [
                  _c(
                    "w-row",
                    { attrs: { "no-margin": "" } },
                    [
                      _c(
                        "w-col",
                        { attrs: { sm: "12" } },
                        [
                          _c("app-select-bank-type", {
                            attrs: { fancy: "", "use-ids": "" },
                            model: {
                              value: _vm.bankTo,
                              callback: function ($$v) {
                                _vm.bankTo = $$v
                              },
                              expression: "bankTo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { sm: "12" } },
                        [
                          _c(
                            "w-info",
                            {
                              attrs: {
                                "ico-lib": "fas",
                                ico: "info-circle",
                                text: "",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$ct("transfer-to", {
                                      bank1: _vm.bankNameFrom,
                                      bank2: _vm.bankNameTo,
                                    })
                                  ) +
                                  " € " +
                                  _vm._s(
                                    _vm._f("printHumanFloat")(_vm.toDeposit)
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm.difference != 0
                        ? _c(
                            "w-col",
                            { attrs: { sm: "12" } },
                            [
                              _c(
                                "w-info",
                                {
                                  staticClass: "mb",
                                  attrs: {
                                    danger: "",
                                    "ico-lib": "fas",
                                    ico: "info-circle",
                                    text: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$ct("difference-to", {
                                          difference: _vm.humandDifference,
                                          bank1: _vm.bankNameFrom,
                                        })
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-card-actions",
                [
                  _c(
                    "w-button",
                    {
                      staticClass: "cancel",
                      on: {
                        click: function ($event) {
                          return _vm.cancelTransfer()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.transfer()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("common.save")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.showPrintModal,
            callback: function ($$v) {
              _vm.showPrintModal = $$v
            },
            expression: "showPrintModal",
          },
        },
        [
          _c(
            "w-card",
            { attrs: { "max-width": "500" } },
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("print-title")))]),
              _c(
                "w-card-content",
                { style: { padding: "0px" }, attrs: { id: "print" } },
                [
                  _c(
                    "w-row",
                    { attrs: { "no-margin": "" } },
                    [
                      _c("w-col", { attrs: { sm: "12" } }, [
                        _c(
                          "table",
                          {
                            style: {
                              border: "none",
                              display: "block",
                              marginTop: "20px",
                              fontFamily: "open sans",
                            },
                          },
                          _vm._l(_vm.cash, function (item, index) {
                            return _c("tr", { key: index }, [
                              _c("td", { style: { width: "80px" } }, [
                                _vm._v(
                                  _vm._s(_vm._f("printHumanFloat")(item[1])) +
                                    " x "
                                ),
                              ]),
                              _c(
                                "td",
                                {
                                  style: { textAlign: "right", width: "100px" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm._f("printHumanFloat")(item[0])) +
                                      " = "
                                  ),
                                ]
                              ),
                              _c(
                                "td",
                                {
                                  style: { textAlign: "right", width: "100px" },
                                },
                                [
                                  _vm._v(
                                    "€ " +
                                      _vm._s(
                                        _vm._f("printHumanFloat")(
                                          item[0] * item[1]
                                        )
                                      )
                                  ),
                                ]
                              ),
                            ])
                          }),
                          0
                        ),
                        _c(
                          "table",
                          {
                            style: {
                              border: "none",
                              marginTop: "20px",
                              display: "block",
                              fontFamily: "open sans",
                            },
                          },
                          [
                            _c("tr", [
                              _c("td", { style: { width: "140px" } }, [
                                _vm._v(_vm._s(_vm.$ct("saldo"))),
                              ]),
                              _c(
                                "td",
                                {
                                  style: { textAlign: "right", width: "142px" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm._f("printHumanFloat")(_vm.saldo))
                                  ),
                                ]
                              ),
                            ]),
                            _c("tr", [
                              _c("td", [_vm._v(_vm._s(_vm.$ct("total")))]),
                              _c("td", { style: { textAlign: "right" } }, [
                                _vm._v(
                                  _vm._s(_vm._f("printHumanFloat")(_vm.totalIn))
                                ),
                              ]),
                            ]),
                            _c("tr", [
                              _c("td", [_vm._v(_vm._s(_vm.$ct("difference")))]),
                              _c("td", { style: { textAlign: "right" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("printHumanFloat")(_vm.difference)
                                  )
                                ),
                              ]),
                            ]),
                            _c("tr", [
                              _c("td", [_vm._v(_vm._s(_vm.$ct("start")))]),
                              _c("td", { style: { textAlign: "right" } }, [
                                _vm._v(
                                  _vm._s(_vm._f("printHumanFloat")(_vm.start))
                                ),
                              ]),
                            ]),
                            _c("tr", [
                              _c(
                                "td",
                                {
                                  style: { paddingTop: "20px" },
                                  attrs: { colspan: "2" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$ct("transfer-to", {
                                          bank1: _vm.bankNameFrom,
                                          bank2: _vm.bankNameTo,
                                        })
                                      ) +
                                      " € " +
                                      _vm._s(
                                        _vm._f("printHumanFloat")(_vm.toDeposit)
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-card-actions",
                [
                  _c(
                    "w-button",
                    {
                      staticClass: "cancel",
                      on: {
                        click: function ($event) {
                          return _vm.cancelPrint()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.print()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("common.print")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }